import React, { Component } from 'react'
import AuthService from "../../services/AuthService";
import '../../css/BisharatMain.css';
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import translate from '../../languages/translate';



export default class PhoneModify extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.onChangeNewNumber = this.onChangeNewNumber.bind(this);
  this.state = {
    oneUser: [],
    newNumber: "",
    userName:"",
    changedNumberSuccessfully : false,
    loading: false,
    message : ""
  };
    }


  onChangeNewNumber(e) {
    this.setState({
        newNumber: e.target.value
    });
  }


  handleChange(e) {
    e.preventDefault();

    this.setState({
      message: "",
      loading: true
    });

    this.form.validateAll();

    if (this.checkBtn.context._errors.length === 0) {
        localStorage.setItem("verifytryCN", "5");
      AuthService.changeNumber(
        this.state.username,
        this.state.newNumber
      ).then(
        response => {
          this.setState({
            changedNumberSuccessfully : true,
            message: response.data.message,
            successful: true
          });
          window.location.href = `/ModifyNumberSMSVerify/${this.state.username}/${this.state.newNumber}`;
        },
        error => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();

          this.setState({
            successful: false,
            message: resMessage,
            changedNumberSuccessfully: false
          });
          window.location.reload();
        }
      );
    } else {
   
      this.setState({
        loading: false
      }); 
    }
  }



  componentDidMount() {
    this.refreshActiveSMSPage();
  }


  refreshActiveSMSPage = ()  => {

    const { match: { params } } = this.props;
        const userName = params.username;
             this.setState({username : userName}
            );   
    }
 
  

  render() {

    const required = value => {
      if (!value) {
        return (
          <div className="alertDanger" >
               <p className="alertDanger">  
         {translate("mandatory")}         
          </p> 
          </div>
        );
      }
    };


    const vphone = value => {
        
        if (!/[0-9]/.test(value)) {
          return (
            <div className="alertDanger" role="alert">
              <p className="alertDanger">
            {translate("numbers-only")}
            </p>
            </div>
          );
        } 
      
        if (value.length !== 10) {
          return (
            <div className="alertDanger" role="alert">
              <p className="alertDanger">
              {translate("phone-10-digits")}
            </p>
            </div>
          );
        }
        var kedom = value.slice(0, 3);
        if (kedom === '050' || kedom === '052' || kedom === '054'
          || kedom === '055' || kedom === '057' || kedom === '058'
        ) {
      
        } else {
          return (
            <div className="alertDanger" role="alert">
              <p className="alertDanger">
              {translate("phone-example")}
              </p>
            </div>
          );
        }
      
      };



    return (
 <div className="activate-user-wrap">
<div className="button-activate-user1">
 
<div className="register-not-signed">
  
   <Form
     onSubmit={this.handleChange}
     ref={c => {
       this.form = c;
     }}
   >
     {!this.state.successful && (
       <div>
         <div className="form-group">
           <label htmlFor="newNumber">{translate("new-phone-num")}</label>
           <Input
             type="text"
             className="form-control-mod"
             name="newNumber"
             value={this.state.newNumber}
             onChange={this.onChangeNewNumber}
             validations={[required, vphone]}
           />
         </div>

         {/* <div className="form-group">
           <label htmlFor="token">{translate("code")}</label>
           <Input
             type="text"
             className="form-control-mod"
             name="token"
             value={this.state.token}
             onChange={this.onChangeToken}
             validations={[required]}            
           />
         </div> */}

         <div className="form-group">
         {/* <button  onClick={() => this.activateUserNow( this.state.username,this.state.token)}>  </button> */}
         <button
                className="btn"
                disabled={this.state.loading}
              >
                {this.state.loading && (
                  <span className="spinner-border spinner-border-sm"></span>
                )}
{translate("modifyphone")
}              </button>
         </div>
         </div>
            )}
     {this.state.message && (
              <div className="form-group">
                <div
                  className={
                    this.state.successful
                      ? "alertSuccess" 
                      : "alertDanger"
                  }
                  role="alert"
                >
                  
                  {this.state.message === 'PhoneNumber Already used' && translate("newphone-used")} 
                  {this.state.message === 'SMS exceed for user' && translate("too-much-tries-change-number")} 
                  
                </div>
              </div>
            )}
            <CheckButton
              style={{ display: "none" }}
              ref={c => {
                this.checkBtn = c;
              }}
            />
          </Form>
          
      

        
          <button className="btn" onClick={this.props.history.goBack}> {translate("back")}  </button>
          </div>
            
 
</div>

    </div>
    )
  }
}